import Text from '@shared/components/content/text';
import Unit, { UnitVariant } from '@shared/components/content/unit';
import { cn, formatNumber } from '@shared/lib/utils';
import { ClassValue } from 'clsx';

type MetricSize = 'lg' | 'md' | 'sm';

interface VariantStyle {
  titleClassName: ClassValue;
  valueClassName?: ClassValue;
  unitClassName?: ClassValue;
}

const sizeStyles: Record<MetricSize, VariantStyle> = {
  lg: {
    titleClassName: 'text-xl',
    valueClassName: 'text-5xl font-medium',
    unitClassName: 'text-xl',
  },
  md: {
    titleClassName: 'text-md',
    valueClassName: 'text-4xl font-medium',
    unitClassName: 'text-md',
  },
  sm: {
    titleClassName: '',
    valueClassName: '',
  },
};

interface ProductMetricProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  value: number | string;
  unit?: UnitVariant;
  size?: MetricSize;
  titleClassName?: ClassValue;
  valueClassName?: ClassValue;
  unitClassName?: ClassValue;
  leftAdornment?: React.ReactNode;
}

export default function ProductMetric({
  title,
  value,
  unit,
  size = 'sm',
  className,
  titleClassName,
  valueClassName,
  unitClassName,
  leftAdornment,
}: ProductMetricProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <Text
        className={cn(
          'font-medium font-inter text-primary-500',
          titleClassName
        )}
      >
        {title}
      </Text>
      <div className="flex items-baseline gap-x-1">
        {leftAdornment && leftAdornment}
        <Text
          variant="reportBody"
          className={cn(
            'text-3xl font-normal text-primary-600',
            valueClassName
          )}
        >
          {typeof value === 'string' ? value : formatNumber(value)}
        </Text>
        <Unit variant={unit!} className={cn(unitClassName, 'text-sm')} />
      </div>
    </div>
  );
}
